import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DetailColumnProps {
  children: ReactNode;
  className?: string;
}

export const DetailColumn = ({ children, className }: DetailColumnProps) => (
  <div className={cn("detail-column", className)}>{children}</div>
);
